import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ForgotPasswordForm } from "@/components/ForgotPasswordForm";

export default function Login() {
  const { login, error, user } = useAuth();
  const [email, setEmail] = useState("davidholon@gmail.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgot, setForgot] = useState(false);
  const nav = useNavigate();

  React.useEffect(() => {
    if (user && user.role) nav("/");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) nav("/");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative overflow-hidden">
        <img
          src="https://customer-assets-4nw71qhi.emergentagent.net/job_travel-ops-central/artifacts/psji7kxl_DSC06076-ARW_DxO_DeepPRIME%20Panorama%20copia.jpg"
          alt="Expedition"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F17] via-[#0B0F17]/50 to-[#0B0F17]/10" />
        <div className="relative z-10 h-full flex flex-col justify-end p-12 text-white">
          <div className="mb-6">
            <img
              src="https://customer-assets-4nw71qhi.emergentagent.net/job_travel-ops-central/artifacts/jrl28zc2_logo%20fondo%20blanco%20solo%20letras.png"
              alt="IceMonkey Photo Expeditions"
              className="h-12 w-auto invert"
            />
          </div>
          <h1 className="text-4xl font-bold leading-tight max-w-md">
            Gestión operativa integral para expediciones fotográficas.
          </h1>
          <p className="mt-4 max-w-md text-white/70">
            Viajes, participantes, pagos, alojamientos, transporte y rentabilidad — todo en un único lugar.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 bg-slate-50 dark:bg-[#0B0F17]">
        <Card className="w-full max-w-md">
          <CardHeader className="items-center text-center">
            <img
              src="https://customer-assets-4nw71qhi.emergentagent.net/job_travel-ops-central/artifacts/jrl28zc2_logo%20fondo%20blanco%20solo%20letras.png"
              alt="IceMonkey Photo Expeditions"
              className="h-10 w-auto mb-3 dark:invert"
            />
            <CardTitle className="text-2xl">{forgot ? "Recuperar contraseña" : "Iniciar sesión"}</CardTitle>
          </CardHeader>
          <CardContent>
            {forgot ? <ForgotPasswordForm initialEmail={email} onBack={() => setForgot(false)} /> : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email">Correo electrónico</Label>
                <Input
                  id="email" type="email" required autoComplete="email"
                  data-testid="login-email"
                  value={email} onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div>
                <Label htmlFor="password">Contraseña</Label>
                <Input
                  id="password" type="password" required autoComplete="current-password"
                  data-testid="login-password"
                  value={password} onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              {error && <div data-testid="login-error" className="text-sm text-red-600">{error}</div>}
              <Button data-testid="login-submit" type="submit" className="w-full bg-[#026FCB] hover:bg-[#0358a5]" disabled={loading}>
                {loading ? "Entrando..." : "Entrar"}
              </Button>
              <button type="button" data-testid="login-forgot-password" className="w-full text-sm text-[#026FCB] hover:underline" onClick={() => setForgot(true)}>
                ¿Olvidaste tu contraseña?
              </button>
              <div className="text-xs text-slate-500 pt-3 border-t border-slate-200 dark:border-[#25334D] text-center space-y-0.5">
                <a href="https://www.icemonkeytours.com" target="_blank" rel="noopener noreferrer" className="text-[#026FCB] hover:underline font-medium">
                  www.icemonkeytours.com
                </a>
                <div className="text-[10px] mono uppercase tracking-widest text-slate-400">
                  Todos los derechos reservados · IceMonkey Inc.
                </div>
              </div>
            </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
